import { Component, inject } from '@angular/core';
import { OptixComponentBase } from './core/utils/base-components/optix-component-base';
import { LogUpdateService } from './core/services/service-worker/log-update.service';
import { PromptUpdateService } from './core/services/service-worker/prompt-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent extends OptixComponentBase {
  title = 'optix 2';

  private logUpdateService: LogUpdateService = inject(LogUpdateService);
  private promptUpdateService: PromptUpdateService = inject(PromptUpdateService);

  public reloadApp(): void {
		// Reload the page to update to the latest version.
		document.location.reload();
  }
}

